// theme.js ou theme.ts
import {createTheme} from '@mui/material/styles';

// Palette de couleurs, typographie et options globales
const theme = createTheme({
    palette: {
        mode: 'light', // ou 'dark'
        primary: {
            main: '#ae7f32',
        },
        secondary: {
            main: '#1e1e1e',
        },
        background: {
            default: '#f5f5f5',
            paper: '#fff',
        },
    },
    typography: {
        fontFamily: 'Roboto, sans-serif',
        h1: {
            marginBottom: '1rem',
            fontSize: '2rem',
            fontWeight: 600,
        },
        button: {
            textTransform: 'none',
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#efefefff',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1e1e1e',
                    color: '#fff',
                },
            },
        },
    },
});

export default theme;
